import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Cria instância Axios apontando para o endpoint principal
const axiosInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/importacaoArquivoRemessaAquisicao`);
const axiosAutomaticaInstance = createAxiosInstance(`${REACT_APP_ESTEIRA_BACK}/rest/importacaoAquisicaoAutomatica`);

export default class RemessasService {
  axios: typeof axiosInstance;
  axiosAutomatica: typeof axiosAutomaticaInstance;

  constructor() {
    this.axios = axiosInstance;
    this.axiosAutomatica = axiosAutomaticaInstance;
  }

  // Listar remessas com paginação
  async listar(page: number = 0, size: number = 10): Promise<any> {
    try {
      const response = await this.axios.get('/listar', {
        params: { page, size },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar remessas:', error);
      throw error;
    }
  }

  // Upload de arquivo
  async upload(formData: FormData): Promise<any> {
    try {
      const response = await this.axios.post('/processarDoc', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar remessa:', error);
      throw error;
    }
  }

  // Download de arquivo por ID ou UUID
  async download(id: number | string): Promise<Blob> {
    try {
      const response = await this.axios.get(`/${id}/download`, {
        responseType: 'blob',
        headers: { Accept: 'text/plain' },
      });
      return new Blob([response.data], { type: 'text/plain' });
    } catch (error) {
      console.error('Erro ao baixar arquivo da remessa:', error);
      throw error;
    }
  }

  // Desfazer uma remessa
  async desfazer(idRemessa: number): Promise<any> {
    try {
      const response = await this.axios.post('/desfazer', null, {
        params: { idRemessa },
      });
      return response.data;
    } catch (error) {
      console.error(`Erro ao desfazer remessa ${idRemessa}:`, error);
      throw error;
    }
  }

  // Processar arquivo de remessa de aquisição
  async exportarCsv(idAquisicao: number): Promise<Blob> {
    try {
        const response = await this.axios.get('/exportarCsv', {
        params: { id_aquisicao: idAquisicao },
        responseType: 'blob',
        headers: { Accept: 'text/csv' },
        });
        return new Blob([response.data], { type: 'text/csv' });
    } catch (error) {
        console.error('Erro ao exportar CSV da remessa de aquisição:', error);
        throw error;
    }
  }

  async baixarLogTxt(idAquisicao: number): Promise<Blob> {
    try {
      const response = await this.axios.get('/downloadLogArquivo', {
        params: { id_aquisicao: idAquisicao },
        responseType: 'blob',
        headers: { Accept: 'text/plain' },
      });
      return new Blob([response.data], { type: 'text/plain;charset=utf-8;' });
    } catch (error) {
      console.error('Erro ao baixar TXT da remessa de aquisição:', error);
      throw error;
    }
  }

  async listarLogsOutrosStatus(idAquisicao: number): Promise<any[]> {
    try {
      const response = await this.axios.get('/listarLogsOutrosStatus', {
        params: { id_aquisicao: idAquisicao },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar logs com outros status:', error);
      throw error;
    }
  }

  async buscarConfiguracaoAutomatica(): Promise<any> {
    try {
      const response = await this.axiosAutomatica.get('/configuracao');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar configuração automática:', error);
      throw error;
    }
  }

  async salvarConfiguracaoAutomatica(configuracao: any): Promise<any> {
    try {
      const response = await this.axiosAutomatica.post('/configuracao', configuracao);
      return response.data;
    } catch (error) {
      console.error('Erro ao salvar configuração automática:', error);
      throw error;
    }
  }

  async testarConexaoAutomatica(configuracao: any): Promise<any> {
    try {
      const response = await this.axiosAutomatica.post('/testarConexao', configuracao);
      return response.data;
    } catch (error) {
      console.error('Erro ao testar conexão automática:', error);
      throw error;
    }
  }

  async executarImportacaoAutomatica(idConfiguracao: number): Promise<any> {
    try {
      const response = await this.axiosAutomatica.post(`/executarAgora/${idConfiguracao}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao executar importação automática:', error);
      throw error;
    }
  }

  async listarHistoricoImportacaoAutomatica(limite: number = 50): Promise<any[]> {
    try {
      const response = await this.axiosAutomatica.get('/historico', {
        params: { limite },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar histórico da importação automática:', error);
      throw error;
    }
  }

}
